import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

// Importaciones necesarias y recomendadas
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

// Para Ionic Storage (almacenamiento local)
import { IonicStorageModule } from '@ionic/storage-angular'; // << IMPORTANTE

// Para manejo de formularios (tanto ngModel como Reactive Forms)
import { FormsModule, ReactiveFormsModule } from '@angular/forms'; // << IMPORTANTE

// Para realizar peticiones HTTP (si vas a conectar con un backend)
import { HttpClientModule } from '@angular/common/http'; // << RECOMENDADO PARA FUTURO

@NgModule({
  declarations: [AppComponent],
  // entryComponents: [], // Ya no es necesario explícitamente con Angular Ivy (Angular 9+)
  imports: [
    BrowserModule,
    IonicModule.forRoot(), // Configuración base de Ionic
    AppRoutingModule,
    IonicStorageModule.forRoot(), // << AÑADIDO: Configura Ionic Storage globalmente
    FormsModule,                 // << AÑADIDO: Para [(ngModel)] si lo usas
    ReactiveFormsModule,         // << AÑADIDO: Para FormGroups, FormArrays, etc.
    HttpClientModule             // << AÑADIDO: Para servicios HTTP
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
    // Los servicios con providedIn: 'root' (como el StorageService que te mostré)
    // no necesitan ser listados aquí.
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
